export function convertQuarterToMonth(quarterValue: string): string {
  if (!quarterValue.includes("-Q")) {
    return quarterValue;
  }

  const quarterToMonth = ["01-01", "04-01", "07-01", "10-01"];
  const { year, quarter } = (() => {
    const [y, m] = quarterValue.split("-Q").map(Number);
    return { year: y, quarter: m };
  })();
  return `${year}-${quarterToMonth[quarter - 1]}`;
}
